<template>
  <div class = "card-curvey" >
    <h2>Overall Campaigns</h2>
    <v-layout row nowrap class="align-center mt-3">
      <v-flex xs6>
        <apex-chart type="donut" height="250" :options="chartOptions" :series="series" ></apex-chart>
      </v-flex>

      <v-flex xs6>
        <div class="legends-list">
          <graph-legend :color="$vuetify.theme.secondary" label="Replied Back" :value="getRation('reply back')" />
          <graph-legend :color="$vuetify.theme.warning" label="Pending" :value="getRation('pending')" />
          <graph-legend color="#1DE9B6" label="Waiting Reply Back" :value="getRation('no feedback')" />
        </div>
      </v-flex>

    </v-layout>

  </div>
</template>

<script>
  import apexChart from 'vue-apexcharts'
  import graphLegend from "./graphLegend";
  export default {
    name: "overallCampaignsPieChart",
    components: {
      apexChart,
      graphLegend
    },
    props: {
      overallData: {
        type: Array,
        default: ()=> {
          return []
        }
      }
    },
    data() {
      return {
        series: [],
        chartOptions: {
          colors: [this.$vuetify.theme.secondary, this.$vuetify.theme.warning , '#1DE9B6' , '#FF4560' , '#775DD0' , '#833B2B'],
          legend: {
            show: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    offsetY: -1,
                    show: true
                  },
                  total: {
                    show: true,
                    label: 'Total Messages',
                    color: '#000'
                  }
                },
              }
            }
          },
          labels: [],
          chart: {
            type: 'donut'
          }
        }
      }
    },
    mounted() {
      this.getChartData()
    },
    methods: {
      getChartData(){
        let label = null
        for (let i=0;i<this.overallData.length;i++) {
          this.series.push(this.overallData[i].count)
          label = this.overallData[i].label.toLowerCase() === 'no feedback' ? 'Waiting Reply Back' : this.overallData[i].label
          label = label === 'reply back' ? 'Replied Back' : label
          this.chartOptions.labels.push(label)
        }
      },
      getRation(label){
        let obj = this.overallData.find(item=>{
          return item.label === label
        })
        return obj.ratio
      }
    }
  }
</script>

<style scoped>
.card-curvey {
  height: 380px
}
@media (max-width: 1627px) {
  .card-curvey {
    height: 352px
  }
}
@media (max-width: 1440px) {
  .card-curvey {
    height: 334px
  }
}
</style>
